import { useState, useMemo,useEffect } from "react";
import Api from "../../api/Api";
import { toast } from "react-toastify";

// ── Padrões fracos a bloquear ──────────────────────────────────────────────
const WEAK_PATTERNS = [
  // Sequências numéricas
  "0000", "00000", "000000", "00000000",
  "1111", "11111", "111111", "11111111",
  "2222", "22222", "222222",
  "3333", "33333", "333333",
  "4444", "44444", "444444",
  "5555", "55555", "555555",
  "6666", "66666", "666666",
  "7777", "77777", "777777",
  "8888", "88888", "888888",
  "9999", "99999", "999999",

  "0123", "01234", "012345", "0123456", "01234567", "012345678", "0123456789",
  "1234", "12345", "123456", "1234567", "12345678", "123456789", "1234567890",
  "2345", "3456", "4567", "5678", "6789",
  "9876", "98765", "987654", "9876543", "98765432", "987654321", "9876543210",
  "8765", "7654", "6543", "5432", "4321", "3210",

  // Letras
  "aaaa", "aaaaa", "aaaaaa", "aaaaaaaa",
  "bbbb", "cccc", "dddd",
  "abcd", "abcde", "abcdef", "abcdefg", "abcdefgh",
  "qwerty", "qwertyui", "qwerty123",
  "asdf", "asdfg", "asdfgh",
  "zxcv", "zxcvb", "zxcvbn",
  "poiuy", "lkjhg", "mnbvc",

  // Palavras comuns
  "password",
  "password1",
  "password123",
  "password1234",
  "password2024",
  "password2025",
  "password2026",
  "pass",
  "passwd",
  "senha",
  "senha123",
  "senha2024",
  "senha2025",
  "senha2026",
  "admin",
  "admin123",
  "administrator",
  "root",
  "root123",
  "user",
  "guest",
  "login",
  "welcome",
  "welcome123",
  "default",
  "test",
  "teste",
  "demo",
  "letmein",
  "secret",
  "access",
  "master",
  "system",

  // Combinações muito usadas
  "abc123",
  "abc12345",
  "123abc",
  "pass123",
  "adminadmin",
  "qwerty123",
  "qwerty1",
  "iloveyou",
  "loveyou",
  "love123",
  "football",
  "soccer",
  "baseball",
  "dragon",
  "monkey",
  "shadow",
  "superman",
  "batman",
  "pokemon",
  "naruto",
  "goku",
  "internet",

  // Teclado
  "1q2w3e",
  "1qaz2wsx",
  "1qazxsw2",
  "qazwsx",
  "zaq12wsx",
  "qwe123",
  "qweasd",
  "asdf123",
  "zxc123",

  // Datas comuns
  "01011990",
  "01011991",
  "01011992",
  "01011993",
  "01011994",
  "01011995",
  "01011996",
  "01011997",
  "01011998",
  "01011999",
  "01012000",
  "2000",
  "2001",
  "2002",
  "2003",
  "2004",
  "2005",
  "2020",
  "2021",
  "2022",
  "2023",
  "2024",
  "2025",
  "2026",

  // Empresas/serviços
  "google",
  "facebook",
  "microsoft",
  "windows",
  "apple",
  "android",
  "gmail",
  "hotmail",
  "outlook",

  // Outros
  "changeme",
  "welcome1",
  "temp123",
  "temporary",
  "guest123",
  "admin2024",
  "admin2025",
  "admin2026",
  "rootroot",
  "trustno1",
  "freedom",
  "hello",
  "hello123",
  "mypassword",
  "mypassword123",
];


function hasSequential(value) {
  const lower = value.toLowerCase();
  return WEAK_PATTERNS.some(p => lower.includes(p));
}



function evaluatePassword(pwd) {
  const checks = {
    length:        pwd.length >= 8,
    uppercase:     /[A-Z]/.test(pwd),
    lowercase:     /[a-z]/.test(pwd),
    number:        /[0-9]/.test(pwd),
    special:       /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/.test(pwd),
    noWeakPattern: pwd.length > 0 && !hasSequential(pwd),
  };

  let score = Object.values(checks).filter(Boolean).length;
  if (pwd.length >= 12) score += 1;

  let level = "none";
  if (pwd.length === 0)  level = "none";
  else if (score <= 2)   level = "weak";
  else if (score <= 4)   level = "medium";
  else                   level = "strong";

  const isValid =
    checks.length && checks.uppercase && checks.lowercase &&
    checks.number && checks.special  && checks.noWeakPattern;

  return { checks, score, level, isValid };
}

const LEVEL_CONFIG = {
  none:   { label: "",       bars: 0, color: "#e2eaf0" },
  weak:   { label: "Fraca",  bars: 1, color: "#ef4444" },
  medium: { label: "Média",  bars: 2, color: "#f59e0b" },
  strong: { label: "Forte",  bars: 3, color: "#22c55e" },
};

// ── Ícone de olho ─────────────────────────────────────────────────────────
function EyeIcon({ open }) {
  return open ? (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94"/>
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19"/>
      <line x1="1" y1="1" x2="23" y2="23"/>
    </svg>
  ) : (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  );
}

// ── Ícone de cadeado ──────────────────────────────────────────────────────
function LockIcon() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="11" rx="2"/>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
    </svg>
  );
}

// ── Modal Principal ────────────────────────────────────────────────────────
export default function ResetPasswordModal({ isOpen, onClose, onSubmit,code ,email  }) {
  const [newPwd,     setNewPwd]     = useState("");
  const [confirmPwd, setConfirmPwd] = useState("");
  const [show,       setShow]       = useState({ next: false, confirm: false });
  const [error,      setError]      = useState("");
  const [loading,    setLoading]    = useState(false);
  const [success,    setSuccess]    = useState(false);
  const [type,    setType]    = useState();


useEffect(() => {
  if (!isOpen) return;

  if (code?.length > 0) {
    setType(0);
  } else {
     setType(1);
  }
}, [isOpen, code]);




  const evaluation = useMemo(() => evaluatePassword(newPwd), [newPwd]);
  const levelInfo  = LEVEL_CONFIG[evaluation.level];

  if (!isOpen) return null;

  const toggleShow  = (field) => setShow(s => ({ ...s, [field]: !s[field] }));

  const handleClose = () => {
    setNewPwd(""); setConfirmPwd("");
    setError(""); setSuccess(false); setLoading(false);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (!evaluation.isValid) {
      setError("A palavra-passe não cumpre todos os requisitos de segurança.");
      return;
    }
    if (newPwd !== confirmPwd) {
      setError("As palavras-passe não coincidem.");
      return;
    }

    setLoading(true);

    // E-mail
    if(type===1){

    const response = await Api.alterPassword({email: email,password:newPwd});
    if(response.success){
        setSuccess(true);
    }
    else{  setSuccess(false);}
    }

     // Code
    if(type===0){

    const response = await Api.validatePassword({code: code,password:newPwd});
    if(response.success){
        setSuccess(true);
    }
    if(response.status===420){  
      
      toast.error('código Inválido');
      setSuccess(false);}
    }

    
    setLoading(false);
  

  };

  const passwordsMatch = confirmPwd.length > 0 && newPwd === confirmPwd;
  const passwordsMiss  = confirmPwd.length > 0 && newPwd !== confirmPwd;
  const showWeakWarning =
  newPwd.length >= 8 &&
  evaluation.checks.uppercase &&
  evaluation.checks.lowercase &&
  evaluation.checks.number &&
  evaluation.checks.special &&
  !evaluation.checks.noWeakPattern;

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

        /* ── OVERLAY ───────────────────────────────────────── */
        .rp-overlay {
          position: fixed;
          inset: 0;
          background: rgba(2, 11, 26, 0.75);
          backdrop-filter: blur(8px);
          -webkit-backdrop-filter: blur(8px);
          display: flex;
          align-items: center;
          justify-content: center;
          z-index: 1000;
          font-family: 'Inter', sans-serif;
          padding: 20px;
          animation: rpOverlayIn 0.25s ease;
        }
        @keyframes rpOverlayIn {
          from { opacity: 0; }
          to   { opacity: 1; }
        }

        /* ── MODAL BOX ─────────────────────────────────────── */
        .rp-modal {
          background: #ffffff;
          border-radius: 22px;
          width: min(460px, 94vw);
          max-height: 94vh;
          overflow-y: auto;
          padding: 0;
          position: relative;
          box-shadow:
            0 40px 100px rgba(0, 0, 0, 0.45),
            0 0 0 1px rgba(0, 174, 255, 0.12);
          animation: rpModalIn 0.38s cubic-bezier(.22,1,.36,1);
        }
        @keyframes rpModalIn {
          from { opacity: 0; transform: translateY(24px) scale(0.95); }
          to   { opacity: 1; transform: translateY(0)    scale(1);    }
        }

        /* scrollbar */
        .rp-modal::-webkit-scrollbar { width: 4px; }
        .rp-modal::-webkit-scrollbar-track { background: transparent; }
        .rp-modal::-webkit-scrollbar-thumb { background: #d0e4f0; border-radius: 99px; }

        /* ── HEADER STRIP ──────────────────────────────────── */
        .rp-header {
          background: linear-gradient(135deg, #00aaff 0%, #0044ee 100%);
          padding: 30px 36px 48px;
          position: relative;
          overflow: hidden;
          border-radius: 22px 22px 0 0;
        }

        /* decorative circles */
        .rp-header::before {
          content: '';
          position: absolute;
          width: 200px; height: 200px;
          border-radius: 50%;
          background: rgba(255,255,255,0.07);
          top: -70px; right: -50px;
          pointer-events: none;
        }
        .rp-header::after {
          content: '';
          position: absolute;
          width: 130px; height: 130px;
          border-radius: 50%;
          background: rgba(255,255,255,0.05);
          bottom: -40px; left: -20px;
          pointer-events: none;
        }

        .rp-header-text {
          position: relative;
          z-index: 1;
        }

        .rp-header-title {
          font-size: 1.3rem;
          font-weight: 700;
          color: #ffffff;
          letter-spacing: -0.02em;
          margin-bottom: 4px;
        }

        .rp-header-sub {
          font-size: 0.82rem;
          color: rgba(255,255,255,0.72);
          font-weight: 400;
        }

        /* ── CLOSE BUTTON ──────────────────────────────────── */
        .rp-close {
          position: absolute;
          top: 16px;
          right: 16px;
          z-index: 10;
          background: rgba(255,255,255,0.18);
          border: none;
          width: 32px; height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #ffffff;
          transition: background 0.2s;
        }
        .rp-close:hover { background: rgba(255,255,255,0.32); }

        /* ── FLOATING ICON ─────────────────────────────────── */
        .rp-float-icon {
          width: 58px; height: 58px;
          border-radius: 16px;
          background: #ffffff;
          display: flex;
          align-items: center;
          justify-content: center;
          position: absolute;
          bottom: -29px;
          left: 36px;
          z-index: 2;
          box-shadow: 0 8px 24px rgba(0, 68, 238, 0.28);
        }

        /* ── BODY ──────────────────────────────────────────── */
        .rp-body {
          padding: 48px 36px 36px;
        }

        /* ── LABELS / FIELDS ───────────────────────────────── */
        .rp-label {
          font-size: 0.76rem;
          font-weight: 600;
          color: #4a6478;
          margin-bottom: 7px;
          display: block;
          letter-spacing: 0.02em;
        }

        .rp-field-block { margin-bottom: 18px; }

        .rp-input-wrapper {
          position: relative;
          display: flex;
          align-items: center;
        }

        .rp-input-icon {
          position: absolute;
          left: 16px;
          color: #9ab0c8;
          pointer-events: none;
          display: flex;
          align-items: center;
          transition: color 0.2s;
        }

        .rp-input {
          width: 100%;
          height: 50px;
          padding: 0 46px;
          border-radius: 12px;
          border: 1.5px solid #e2eaf0;
          background: #f5f9fd;
          font-size: 0.9rem;
          color: #1a2b3c;
          font-family: 'Inter', sans-serif;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s, background 0.2s;
        }
        .rp-input::placeholder { color: #a8bfcf; }
        .rp-input:focus {
          border-color: #0090e7;
          background: #ffffff;
          box-shadow: 0 0 0 3px rgba(0,144,231,0.13);
        }
        .rp-input:focus ~ .rp-input-icon,
        .rp-input-wrapper:focus-within .rp-input-icon { color: #0090e7; }

        .rp-input.rp-input-ok    { border-color: #22c55e; }
        .rp-input.rp-input-error { border-color: #ef4444; }

        .rp-toggle-pass {
          position: absolute;
          right: 14px;
          background: none;
          border: none;
          cursor: pointer;
          color: #9ab0c8;
          display: flex;
          align-items: center;
          padding: 4px;
          transition: color 0.2s;
        }
        .rp-toggle-pass:hover { color: #0090e7; }

        /* ── STRENGTH BARS ─────────────────────────────────── */
        .rp-strength-wrap {
          margin: 12px 0 16px;
        }

        .rp-strength-row {
          display: flex;
          gap: 6px;
          margin-bottom: 6px;
        }

        .rp-bar {
          flex: 1;
          height: 5px;
          border-radius: 99px;
          background: #e2eaf0;
          transition: background 0.35s ease;
        }

        .rp-strength-meta {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .rp-strength-label {
          font-size: 0.73rem;
          font-weight: 600;
          transition: color 0.3s;
        }

        .rp-strength-hint {
          font-size: 0.7rem;
          color: #b0c2d0;
        }

        /* ── REQUIREMENTS GRID ─────────────────────────────── */
        .rp-requirements {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 8px 14px;
          background: #f5f9fd;
          border-radius: 14px;
          padding: 14px 16px;
          margin-bottom: 20px;
          border: 1px solid #e8f0f8;
        }

        .rp-req {
          display: flex;
          align-items: center;
          gap: 7px;
          font-size: 0.72rem;
          color: #a8bfcf;
          transition: color 0.25s ease;
          font-weight: 500;
        }
        .rp-req.rp-req-met { color: #22c55e; }

        .rp-req-icon {
          display: flex;
          align-items: center;
          flex-shrink: 0;
          width: 16px; height: 16px;
          border-radius: 50%;
          background: #e8f0f8;
          justify-content: center;
          transition: background 0.2s;
        }
        .rp-req.rp-req-met .rp-req-icon {
          background: #dcfce7;
          color: #22c55e;
        }

        /* ── MATCH FEEDBACK ────────────────────────────────── */
        .rp-match-feedback {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 0.74rem;
          font-weight: 500;
          margin-top: 8px;
          padding-left: 2px;
        }
        .rp-match-ok  { color: #22c55e; }
        .rp-match-bad { color: #ef4444; }

        /* ── ERROR BOX ─────────────────────────────────────── */
        .rp-error-box {
          display: flex;
          align-items: flex-start;
          gap: 10px;
          font-size: 0.78rem;
          color: #7f1d1d;
          padding: 12px 14px;
          background: #fef2f2;
          border-radius: 10px;
          border-left: 3px solid #ef4444;
          margin-bottom: 16px;
          line-height: 1.5;
        }

        /* ── SUBMIT BUTTON ─────────────────────────────────── */
        .rp-btn {
          width: 100%;
          height: 52px;
          border-radius: 13px;
          border: none;
          cursor: pointer;
          font-size: 0.92rem;
          font-weight: 700;
          letter-spacing: 0.07em;
          text-transform: uppercase;
          color: #fff;
          background: linear-gradient(135deg, #00aaff 0%, #0044ee 100%);
          box-shadow: 0 6px 24px rgba(0,100,255,0.32);
          transition: transform 0.18s, box-shadow 0.18s, filter 0.18s, opacity 0.18s;
          font-family: 'Inter', sans-serif;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-top: 4px;
        }
        .rp-btn:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 12px 32px rgba(0,100,255,0.46);
          filter: brightness(1.07);
        }
        .rp-btn:active:not(:disabled) {
          transform: translateY(0);
          box-shadow: 0 4px 14px rgba(0,100,255,0.28);
        }
        .rp-btn:disabled { opacity: 0.52; cursor: not-allowed; }

        .rp-spinner {
          width: 16px; height: 16px;
          border: 2px solid rgba(255,255,255,0.38);
          border-top-color: #fff;
          border-radius: 50%;
          animation: rpSpin 0.7s linear infinite;
        }
        @keyframes rpSpin { to { transform: rotate(360deg); } }

        /* ── SUCCESS STATE ─────────────────────────────────── */
        .rp-success-wrap {
          text-align: center;
          padding: 12px 0 8px;
        }

        .rp-success-icon {
          width: 76px; height: 76px;
          border-radius: 50%;
          background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
          display: flex; align-items: center; justify-content: center;
          margin: 0 auto 24px;
          box-shadow: 0 12px 32px rgba(34,197,94,0.35);
          animation: rpSuccessPop 0.5s cubic-bezier(.22,1,.36,1);
        }
        @keyframes rpSuccessPop {
          0%   { transform: scale(0) rotate(-15deg); }
          60%  { transform: scale(1.12) rotate(3deg); }
          100% { transform: scale(1) rotate(0deg); }
        }

        .rp-success-title {
          font-size: 1.35rem;
          font-weight: 700;
          color: #0d1b2a;
          margin-bottom: 8px;
          letter-spacing: -0.02em;
        }

        .rp-success-sub {
          font-size: 0.85rem;
          color: #7a8fa6;
          line-height: 1.6;
          margin-bottom: 28px;
        }

.rp-weak-warning {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.76rem;
  color: #92400e;
  padding: 10px 12px;
  background: #fffbeb;
  border-radius: 10px;
  border-left: 3px solid #f59e0b;
  margin-bottom: 14px;
  line-height: 1.5;
  font-weight: 500;
  animation: rpOverlayIn 0.2s ease;
}



      `}</style>

      <div className="rp-overlay" onClick={handleClose}>
        <div className="rp-modal" onClick={e => e.stopPropagation()}>

          {/* ── HEADER ── */}
          <div className="rp-header">
            <button className="rp-close" onClick={handleClose} aria-label="Fechar">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                   strokeWidth="2.5" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18"/>
                <line x1="6" y1="6" x2="18" y2="18"/>
              </svg>
            </button>

            <div className="rp-header-text">
              <div className="rp-header-title">Criar nova palavra-passe</div>
              <div className="rp-header-sub">Define uma nova palavra-passe segura para a tua conta</div>
            </div>

 
          </div>

          {/* ── BODY ── */}
          <div className="rp-body">

            {!success ? (
              <form onSubmit={handleSubmit}>

                {/* Nova senha */}
                <div className="rp-field-block">
                  <label className="rp-label">Nova palavra-passe</label>
                  <div className="rp-input-wrapper">
                    <span className="rp-input-icon"><LockIcon /></span>
                    <input
                      type={show.next ? "text" : "password"}
                      className="rp-input"
                      placeholder="Cria uma palavra-passe forte"
                      value={newPwd}
                      onChange={e => { setNewPwd(e.target.value); setError(""); }}
                      autoFocus
                    />
                    <button type="button" className="rp-toggle-pass" onClick={() => toggleShow("next")}>
                      <EyeIcon open={show.next} />
                    </button>
                  </div>

                  {/* Strength bars — só aparecem quando há input */}
                  {newPwd.length > 0 && (
                    <div className="rp-strength-wrap">
                      <div className="rp-strength-row">
                        {[0, 1, 2].map(i => (
                          <div
                            key={i}
                            className="rp-bar"
                            style={{
                              background: i < levelInfo.bars ? levelInfo.color : "#e2eaf0"
                            }}
                          />
                        ))}
                      </div>
                      <div className="rp-strength-meta">
                        <span className="rp-strength-label" style={{ color: levelInfo.color }}>
                          {levelInfo.label}
                        </span>
                        <span className="rp-strength-hint">
                          {evaluation.level === "weak"   && "Adiciona maiúsculas, números e símbolos"}
                          {evaluation.level === "medium" && "Quase lá! Adiciona mais variedade"}
                          {evaluation.level === "strong" && "Excelente palavra-passe! ✓"}
                        </span>
                      </div>
                    </div>
                  )}
                </div>
                {showWeakWarning && (
  <div className="rp-weak-warning">
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#f59e0b"
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0, marginTop:1}}>
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
      <line x1="12" y1="9" x2="12" y2="13"/>
      <line x1="12" y1="17" x2="12.01" y2="17"/>
    </svg>
    A palavra-passe contém sequências previsíveis (ex: "1234", "abcd", "qwerty").
    Tenta substituir por combinações aleatórias.
  </div>
)}

                {/* Requisitos */}
                <div className="rp-requirements">
                  <Req met={evaluation.checks.length}        label="Mín. 8 caracteres" />
                  <Req met={evaluation.checks.uppercase}     label="Letra maiúscula" />
                  <Req met={evaluation.checks.lowercase}     label="Letra minúscula" />
                  <Req met={evaluation.checks.number}        label="Número (0-9)" />
                  <Req met={evaluation.checks.special}       label="Caractere especial" />
                  <Req met={evaluation.checks.noWeakPattern} label="Sem padrões óbvios" />
                </div>

                {/* Confirmar senha */}
                <div className="rp-field-block">
                  <label className="rp-label">Confirmar palavra-passe</label>
                  <div className="rp-input-wrapper">
                    <span className="rp-input-icon"><LockIcon /></span>
                    <input
                      type={show.confirm ? "text" : "password"}
                      className={`rp-input ${passwordsMatch ? "rp-input-ok" : ""} ${passwordsMiss ? "rp-input-error" : ""}`}
                      placeholder="Repete a palavra-passe"
                      value={confirmPwd}
                      onChange={e => { setConfirmPwd(e.target.value); setError(""); }}
                    />
                    <button type="button" className="rp-toggle-pass" onClick={() => toggleShow("confirm")}>
                      <EyeIcon open={show.confirm} />
                    </button>
                  </div>

                  {/* Match feedback */}
                  {confirmPwd.length > 0 && (
                    <div className={`rp-match-feedback ${passwordsMatch ? "rp-match-ok" : "rp-match-bad"}`}>
                      {passwordsMatch ? (
                        <>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                            <polyline points="20 6 9 17 4 12"/>
                          </svg>
                          As palavras-passe coincidem
                        </>
                      ) : (
                        <>
                          <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round">
                            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
                          </svg>
                          As palavras-passe não coincidem
                        </>
                      )}
                    </div>
                  )}
                </div>

                {/* Erro geral */}
                {error && (
                  <div className="rp-error-box">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#ef4444"
                         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" style={{flexShrink:0,marginTop:1}}>
                      <circle cx="12" cy="12" r="10"/>
                      <line x1="12" y1="8" x2="12" y2="12"/>
                      <line x1="12" y1="16" x2="12.01" y2="16"/>
                    </svg>
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  className="rp-btn"
                  disabled={loading || !evaluation.isValid || !passwordsMatch}
                >
                  {loading ? (
                    <><span className="rp-spinner" /> A guardar...</>
                  ) : (
                    <>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                           strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                        <polyline points="20 6 9 17 4 12"/>
                      </svg>
                      Guardar nova palavra-passe
                    </>
                  )}
                </button>

              </form>
            ) : (
              /* ── SUCCESS ── */
              <div className="rp-success-wrap">
                <div className="rp-success-icon">
                  <svg width="34" height="34" viewBox="0 0 24 24" fill="none" stroke="#fff"
                       strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                    <polyline points="20 6 9 17 4 12"/>
                  </svg>
                </div>
                <div className="rp-success-title">Palavra-passe definida!</div>
                <div className="rp-success-sub">
                  A tua palavra-passe foi atualizada com sucesso.<br/>
                  Já podes iniciar sessão com a nova palavra-passe.
                </div>
                <button className="rp-btn" onClick={handleClose}>
                  Ir para o login
                </button>
              </div>
            )}

          </div>{/* end body */}
        </div>
      </div>
    </>
  );
}

// ── Componente de requisito ────────────────────────────────────────────────
function Req({ met, label }) {
  return (
    <div className={`rp-req ${met ? "rp-req-met" : ""}`}>
      <span className="rp-req-icon">
        {met ? (
          <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="20 6 9 17 4 12"/>
          </svg>
        ) : (
          <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor"
               strokeWidth="2.5" strokeLinecap="round">
            <circle cx="12" cy="12" r="8"/>
          </svg>
        )}
      </span>
      {label}
    </div>
  );
}